import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import eCommerceOne from "./assets/e-commerce/e-commerce_1.png";
import eCommerceTwo from "./assets/e-commerce/e-commerce_2.png";
import eCommerceThree from "./assets/e-commerce/e-commerce_3.png";
import eCommerceFour from "./assets/e-commerce/e-commerce_4.png";
import eCommerceFive from "./assets/e-commerce/e-commerce_5.png";
import eCommerceSeven from "./assets/e-commerce/e-commerce_7.png";
import eCommerceEight from "./assets/e-commerce/e-commerce_8.png";
import eCommerceNine from "./assets/e-commerce/e-commerce_9.png";

import webDevSeven from "./assets/web-dev/web_dev_7.png";

import bannerImage from "./assets/e-commerce/e-commerce_6.jpg";
import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const ECommerceDev = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [
    eCommerceOne,
    eCommerceTwo,
    eCommerceThree,
    eCommerceFour,
    eCommerceFive,
  ];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000);

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              E-Commerce Development
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              E-commerce Development
            </Typography>
            <Typography variant="body1" paragraph>
              The E-commerce industry is experiencing unprecedented growth, with
              global revenue expected to climb to $7 trillion by 2028, nearly
              doubling from $3.5 trillion in 2024. This massive surge clearly
              indicates that the future of retail lies in the digital
              marketplace. If you're planning to take your business online,
              there's no better time than now—and we're here to help make that
              transition seamless and impactful.
            </Typography>

            <Typography variant="body1" paragraph>
              Our E-commerce development services are designed to equip your
              business with a powerful digital presence that reaches a global
              customer base. Whether you're launching a new store or upgrading
              an existing one, we deliver end-to-end solutions tailored to your
              specific needs. From intuitive UI/UX design to secure payment
              integration and scalable backend systems, we handle every aspect
              with precision. As an experienced E-commerce development partner,
              our focus is on building high-performance platforms that not only
              look professional but are optimized to drive conversions, increase
              visibility, and support long-term business growth
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Why us?
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Are you wondering why you should entrust your E-commerce
              development project to us? Here are compelling reasons that set us
              apart. We combine deep industry knowledge with the latest
              technologies to deliver robust, scalable, and user-friendly
              E-commerce solutions tailored specifically to your business needs.
              Our dedicated team works closely with you from concept to launch,
              ensuring transparent communication and timely delivery. We
              prioritize security, performance, and seamless integration to help
              you build customer trust and drive sales. With a proven track
              record of successful projects, we are committed to making your
              online store stand out in a competitive market.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={eCommerceSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Years of experience
            </Typography>
            <Typography variant="body1">
              With many years of experience under our belt, we confidently take
              on the responsibility of delivering your next E-commerce project.
              Our skilled developers are experts at building secure, reliable,
              and scalable E-commerce websites designed to meet and exceed your
              unique requirements and expectations. We focus on creating
              seamless user experiences while ensuring your platform is robust
              and capable of handling growing traffic and transactions
              efficiently.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Latest tools and technologies
            </Typography>
            <Typography variant="body1">
              Whether it is Angular, .NET, Python, PHP, Laravel, React, or
              Node.js – we are equipped with the latest tools and technologies
              to deliver cutting-edge products that stand out in today’s
              competitive market. Our team continuously stays updated with
              emerging trends, best practices, and innovations to ensure your
              project benefits from the most effective solutions available.
              Beyond just development, we focus on creating optimized, scalable,
              and user-friendly platforms that enhance your business’s online
              visibility and attract high-quality, engaged visitors. From
              seamless performance to responsive design, we work diligently to
              help your E-commerce website not only launch successfully but also
              grow and thrive in the long run.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={eCommerceEight}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={eCommerceNine}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Affordable E-commerce development
            </Typography>
            <Typography variant="body1">
              Building a powerful online store doesn’t have to break the bank.
              At our company, we believe that high-quality E-commerce
              development should be accessible to businesses of all sizes.
              That’s why we offer cost-effective solutions without compromising
              on performance, design, or functionality. Whether you're a startup
              or an established business looking to expand your online
              footprint, our team works closely with you to understand your
              needs and budget. From sleek storefronts to robust backend
              systems, we tailor every feature to fit your goals—at a price that
              makes sense. Our affordable E-commerce packages include responsive
              design, secure payment gateways, product management tools, SEO
              optimization, and scalable architecture—ensuring you get
              everything you need to thrive in the digital marketplace.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Extended Support
            </Typography>
            <Typography variant="body1">
              We are committed to helping you maintain the highest standards in
              your E-commerce platform long after launch. Partnering closely
              with you, we aim to elevate your business to the next level by
              providing ongoing support and timely assistance whenever you need
              it. Whether you have questions, require updates, or need technical
              troubleshooting, our dedicated development team is always just a
              call or message away. We believe that continuous collaboration and
              quick response times are key to ensuring your website remains
              secure, efficient, and aligned with your evolving business goals.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={webDevSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default ECommerceDev;
